import Seo from "@/components/Seo";
import Header from "@/components/landing/Header";
import IndustryStrip from "@/components/landing/IndustryStrip";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Calculator from "@/components/landing/Calculator";
import HowItWorks from "@/components/landing/HowItWorks";
import DemoVideo from "@/components/landing/DemoVideo";
import TryIt from "@/components/landing/TryIt";
import Pipeline from "@/components/landing/Pipeline";
import WeeklyReport from "@/components/landing/WeeklyReport";
import Bento from "@/components/landing/Bento";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";

export default function Home() {
  return (
    <>
      <Seo
        title="Backfill | Missed-Call & Lead Follow-Up for Contractors"
        description="Backfill helps contractors follow up with missed calls, web leads, and outstanding estimates. See how it works and book a walkthrough."
      />
      <Header />
      <IndustryStrip />
      <main>
        <Hero />
        <Marquee />
        <Calculator />
        <HowItWorks />
        <DemoVideo />
        <TryIt />
        <Pipeline />
        <WeeklyReport />
        <Bento />
        <Testimonials />
        <Pricing />
        <FAQ />
        <LeadForm source="hvac" />
      </main>
      <Footer />
    </>
  );
}
